module.exports = __webpack_public_path__ + "static/public/media/eAMs_greybg.b71e16d0.gif";